import { render } from "./Parametre.vue?vue&type=template&id=324a7a28"
import script from "./Parametre.vue?vue&type=script&lang=js"
export * from "./Parametre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__